import users from "./users";

export default {
  namespaced: true,
  modules: {
    users
  }
};
